import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import bgPng from "../img/hero-bg.png";
import bgPngSp from "../img/hero-bg-sp.png";
import TitlePng from "../img/title.png";
import ScrollSvg from "../img/scroll.svg";
import device, { getDevice } from "../helpers/device";

export default function Hero() {
  const [mounted, setMounted] = useState(false);
  const [posY, setPosY] = useState(null);
  const [posX, setPosX] = useState(null);
  const [scrollCls, setScrollCls] = useState(false);
  const logoImgRef = useRef(null);

  function calcPos() {
    const centerX = window.innerWidth / 2;
    const centerY = window.innerHeight / 2;
    const imgCenterX = logoImgRef.current.width / 2;
    const imgCenterY = logoImgRef.current.height / 2;
    setPosX(centerX - imgCenterX);
    setPosY(centerY - imgCenterY);
  }

  function onLoadLogo() {
    window.addEventListener("resize", () => {
      if (getDevice() !== "sp") {
        calcPos();
      }
    });
    window.addEventListener("orientationchange", () => {
      setTimeout(() => {
        calcPos();
      }, 200);
    });
    calcPos();
  }

  function onScroll() {
    if (window.pageYOffset > 10) {
      setScrollCls(true);
    } else {
      setScrollCls(false);
    }
  }

  useEffect(() => {
    if (mounted) return;
    window.addEventListener("scroll", () => {
      onScroll();
    });
    onScroll();
    setMounted(true);
  });

  return (
    <Wrapper>
      <img
        ref={logoImgRef}
        className="title"
        src={TitlePng}
        alt="CA BASE CAMP"
        style={{ left: `${posX}px`, top: `${posY}px` }}
        onLoad={onLoadLogo}
      />
      <Scroll className={scrollCls ? "hide" : ""}>
        <img src={ScrollSvg} alt="scroll" />
      </Scroll>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  positon: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  pointer-events: none;
  &:before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: url(${bgPngSp}) no-repeat center center;
    background-size: cover;
  }
  @media ${device.mobileL} {
    background: url(${bgPng}) no-repeat center center;
    background-size: cover;
    &:before {
      display: none;
    }
  }
  .title {
    width: 66.6%;
    position: fixed;
    @media ${device.mobileL} {
      position: static;
      top: auto;
      width: 417px;
    }
  }
`;

const Scroll = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  transition: opacity 0.1s linear;
  &.hide {
    opacity: 0;
  }
  > img {
    width: 68px;
  }
  &:after {
    content: "";
    display: block;
    width: 1px;
    height: 40px;
    background: #3f271e;
    margin: 0 auto;
  }
`;
